<template>
  <button
    class="button-toggle"
    :data-off="!isVisibleSecretLanguageChange"
    @click="toggleIsVisibleSecretLanguageChange"
  >
    <ToggleSwitch :modelValue="isVisibleSecretLanguageChange" />
    실험실 컨트롤러 보기
  </button>
</template>

<script setup lang="ts">
import { inject, Ref } from 'vue';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import {
  ij_isVisibleSecretLangaugeChange,
  ij_toggleIsVisibleSecretLangaugeChange,
} from '@/utils/injectionKeys';

const isVisibleSecretLanguageChange = inject<Ref<boolean>>(
  ij_isVisibleSecretLangaugeChange
);
const toggleIsVisibleSecretLanguageChange = inject(
  ij_toggleIsVisibleSecretLangaugeChange
);
</script>

<style scoped lang="scss"></style>
